import isMobile from '@pro/common/utils/isMobile';

// 设置手机浏览器可视区域宽高（不包括导航栏、地址栏、操作栏的区域）
function setAppVisibleArea(isMobile) {
  if (!isMobile) {
    document.documentElement.style.removeProperty('--app-visible-width');
    document.documentElement.style.removeProperty('--app-visible-height');
    return;
  }

  let pageWidth = window.innerWidth;
  let pageHeight = window.innerHeight;

  if (typeof pageWidth !== 'number') {
    //在标准模式下面
    if (document.compatMode === 'CSS1Compat') {
      pageWidth = document.documentElement.clientWidth;
      pageHeight = document.documentElement.clientHeight;
    } else {
      pageWidth = document.body.clientWidth;
      pageHeight = document.body.clientHeight;
    }
  }

  document.documentElement.style.setProperty('--app-visible-width', `${pageWidth }px`);
  document.documentElement.style.setProperty('--app-visible-height', `${pageHeight }px`);
}

const overloadCss = function () {
  const resetWindowScrollTop = () => {
    if (window.scrollY > 0) {
      window.scrollTo(0, 0);
    }
  };
  const switchClass = () => {
    if (isMobile()) {
      document?.body?.classList?.toggle('app-mode', true);

      // 解决ios中键盘弹出时window向上滚动不回滚的问题
      window.addEventListener('focusout', resetWindowScrollTop);

      setAppVisibleArea(true);
    } else {
      document?.body?.classList?.toggle('app-mode', false);

      window.removeEventListener('focusout', resetWindowScrollTop);

      setAppVisibleArea(false);
    }
  };
  switchClass();
  window.addEventListener('resize', switchClass);
};

const compatibleWithSelect = function () {
  document.body.addEventListener('touchstart', (e) => {
    let move = false;
    let target = e.target;
    if (
      !target.classList.contains('el-select-dropdown__item')
      && !(target.parentNode && target.parentNode.classList.contains('el-select-dropdown__item'))
    ) {
      return;
    }
    function handleTouchMove() {
      move = true;
    }
    function handleTouchEnd() {
      if (!move) {
        target.click();
      }
      target.removeEventListener('touchmove', handleTouchMove);
      target.removeEventListener('touchend', handleTouchEnd);
    }
    target.addEventListener('touchmove', handleTouchMove);
    target.addEventListener('touchend', handleTouchEnd);
  });
};

//兼容移动端
overloadCss();
if (isMobile()) {
  if ((/iPhone|iPad/i).test(navigator.userAgent)) {
    compatibleWithSelect();
  }
}
